import { getContrastColor } from "../SelectStyle";
import styles from "./TagList.module.css";

interface Props {
    tags: {
        label: string;
        value: string;
    }[];

    accentColor: string;
}

export default function TagList({ accentColor, tags }: Props) {
    return (
        <div
            className={styles.tagList}
            style={
                {
                    "--tag-color": getContrastColor(accentColor),
                    "--tag-back-color": accentColor,
                } as React.CSSProperties
            }
        >
            {tags.map((tag) => {
                return (
                    <div key={tag.value} className={styles.tag}>
                        {tag.label}
                    </div>
                );
            })}
        </div>
    );
}
